import {ICasinofiedApplication} from './apps/casinofied-application.interface';
import {AppIdentifiers, ComponentID, IOpenAppData} from '@sparkware/uc-sdk-core';
import {ChatApplication} from './apps/chat/chat.application';
import {IServiceFactoryExtended} from '../../service-factory-extended.interface';
import {CasinofiedAppSdkLoader} from './casinofied-app-sdk-loader';
import {ICasinofiedComponent} from './components/casinofied-component.interface';
import {CasinofiedBubbleComponent} from './components/casinofied-bubble.component';
import {InsideDrawerApplication} from './apps/inside-drawer.application';
import {ICasinofiedAppFactory, ICasinofiedComponentFactory} from './casinofied-app-factory.interfaces';
import {DepositWidgetApplication} from "./apps/deposit-widget/deposit-widget.application";
import {PaymentsRedirectApplication} from "./apps/payments-redirect/payments-redirect.application";
import {FullCashierApplication} from "./apps/full-cashier/full-cashier.application";
import {CashoutWidgetApplication} from './apps/cashout-widget/cashout-widget.application';
import {CustomerRelationsApplication} from "./apps/customer-relations/customer-relations.application";

export class CasinofiedAppFactory implements ICasinofiedAppFactory, ICasinofiedComponentFactory{
    constructor(private readonly _services: IServiceFactoryExtended) {
        this._appSdkLoader = new CasinofiedAppSdkLoader(_services);
    }

    private readonly _appSdkLoader: CasinofiedAppSdkLoader;

    createApplication(openAppData: IOpenAppData): ICasinofiedApplication {
        switch (openAppData.appID) {
            case AppIdentifiers.CrChat:
                return new ChatApplication(openAppData, this, this._appSdkLoader, this._services, false);
            case AppIdentifiers.OpenBanking:
                return new InsideDrawerApplication(openAppData, this, this._appSdkLoader, this._services, false);
            case AppIdentifiers.UnifiedCashier:
                return new DepositWidgetApplication(openAppData, this, this._appSdkLoader, this._services);
            case AppIdentifiers.Redirect:
                return new PaymentsRedirectApplication(openAppData, this, this._appSdkLoader, this._services);
            case AppIdentifiers.FullCashier:
                return new FullCashierApplication(openAppData, this._services);
            case AppIdentifiers.UnifiedCashout:
                return new CashoutWidgetApplication(openAppData, this, this._appSdkLoader, this._services);
            case AppIdentifiers.CustomerRelations:
                return new CustomerRelationsApplication(openAppData, this._services);
            default:
                throw new Error(`Application with ID ${openAppData.appID} is not supported`);
        }
    }

    createComponent(componentId: ComponentID): ICasinofiedComponent {
        switch (componentId) {
            case 'CR_CHAT_BUBBLE':
                return new CasinofiedBubbleComponent(componentId, this._appSdkLoader, this._services);
            default:
                throw new Error(`Component with ID ${componentId} is not supported`);
        }
    }
}
